import Promise from 'promise-polyfill';

export function RunningTotal() {
  const promise = new Promise((resolve, reject) => {
    try {
      RS.Modules.UserStatus.runningTotal(); // eslint-disable-line no-undef
      resolve(true);
    } catch (e) {
      reject(e);
    }
  });
  return promise;
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/UserStatus/UserStatus.js